import { useRouteError, useNavigate } from 'react-router-dom';
import { ChunkLoadFailurePanel } from '@components/ChunkLoadError';
import { isChunkLoadError } from '@lib/chunkLoad';
import { ErrorPageView } from './ErrorPageView';

const ErrorPage = () => {
  const error = useRouteError() as any;
  const navigate = useNavigate();
  console.error(error);

  if (isChunkLoadError(error)) {
    return <ChunkLoadFailurePanel error={error} />;
  }

  return <ErrorPageView error={error} onNavigate={() => navigate('/')} />;
};

export default ErrorPage;
